import { render, staticRenderFns } from "./userMGT-complaint-details.vue?vue&type=template&id=fee00e70&scoped=true&"
import script from "./userMGT-complaint-details.vue?vue&type=script&lang=js&"
export * from "./userMGT-complaint-details.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-complaint-details.vue?vue&type=style&index=0&id=fee00e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee00e70",
  null
  
)

export default component.exports